const features = [
  {
    icon: 'ri-play-circle-fill',
    title: '即点即看',
    desc: '无需下载安装任何软件，打开浏览器就能看黑料视频在线播放，高清流畅不卡顿。支持手机和电脑自适应屏幕。',
  },
  {
    icon: 'ri-timer-flash-fill',
    title: '极速更新',
    desc: '7x24小时不间断追踪全网热点，黑料网在线观看内容第一时间同步更新。从事件发生到上线播放，最快仅需15分钟。',
  },
  {
    icon: 'ri-shield-check-fill',
    title: '安全无忧',
    desc: '黑料在线观看无需注册登录，保护您的隐私。平台采用HTTPS加密传输，浏览记录不泄露，放心吃瓜无后顾之忧。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-star-fill"></i>
            平台特色
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            为什么选择我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            黑料网下载的核心优势，带来极致观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-secondary-200/60 rounded-xl p-6 md:p-8 text-center hover:border-primary-200 transition-colors cursor-default"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl mb-5 mx-auto ${
                i === 0 ? 'bg-primary-100' : i === 1 ? 'bg-accent-100' : 'bg-secondary-100'
              }`}>
                <i className={`${f.icon} text-2xl md:text-3xl ${
                  i === 0 ? 'text-primary-500' : i === 1 ? 'text-accent-500' : 'text-secondary-500'
                }`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}